module.exports = __webpack_public_path__ + "img/6.7347d170.jpeg";